import $ from 'jquery';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';

const stickyFooter = {
  init() {
    // main body content container
    this.mainContainer = $('#main-container');
    // main footer container
    this.footerContainer = $('#footer-container');
    // footer content container
    this.footerContent = $('#footer-content');
    this.reset();
  },
  // reset size of footer offset so footer "sticks" to the bottom
  reset() {
    const height = this.footerContent.height();
    this.mainContainer.css({ 'margin-bottom': `-${height}px`, 'padding-bottom': `${height}px` });
    this.footerContainer.height(height);
  },

};

// on window reset rerun the reset function
$(window).on('load', () => new ResizeSensor(stickyFooter.footerContainer, () => stickyFooter.reset()));

export default stickyFooter;
